export const mapWardToDataTable = (data, districtId) => {
  return data.map((district) => ({
    ...district,
  }));
};

export const wardColumns = [
  { key: "wardName", label: "Ward Name", align: "center" },
  { key: "wardCode", label: "Ward Code", align: "center" },
];
